import { FC, RefObject } from 'react';
import { useTranslate } from '../../../../../hooks/context/useTranslate';
import EmptyMessagePortal from '../EmptyMessagePortal/EmptyMessagePortal';
import EmptyMessage from '../EmptyMessage/EmptyMessage';

interface EmptyMessageWithLoadingProps {
  dataLoading: boolean;
  isDataLoaded: boolean;
  containerRef: RefObject<HTMLElement | null>;
  targetSelector: string;
}

const EmptyMessageWithLoading: FC<EmptyMessageWithLoadingProps> = ({
  dataLoading,
  isDataLoaded,
  containerRef,
  targetSelector,
}) => {
  const { t } = useTranslate();

  // Keep the portal mounted so its inline placeholder keeps the empty tbody at
  // height. Show the message only once the dataset has actually resolved and is
  // not loading, so it neither flashes before the first load nor bleeds under
  // the loading overlay.
  const showMessage = isDataLoaded && !dataLoading;

  return (
    <EmptyMessagePortal targetSelector={targetSelector} containerRef={containerRef}>
      {showMessage && <EmptyMessage message={t('noRecordsDataset')} />}
    </EmptyMessagePortal>
  );
};

export default EmptyMessageWithLoading;
